module.exports = __webpack_public_path__ + "img/top-logo.ef71b7dc.png";